import { useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

import NotesModalHistory from "./NotesModalHistory";
import "./notesModal.css";

function NoteAddModalTreatment({
  show,
  handleClose,
  handleFormSubmission,
  data,
  pannel,
  module,
  caseProvider = {},
}) {
  const descriptionRef = useRef(null);
  const [saving, setSaving] = useState(false);

  const sendData = async (event) => {
    event.preventDefault();
    const description = descriptionRef.current?.value.trim();
    if (!description || saving) return;

    setSaving(true);
    try {
      // Keep the shared notes popup's existing submission contract.
      await handleFormSubmission(description, description);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="m-900max treatment-notes-modal"
    >
      <Modal.Header className="tfbp-modal-header">
        <Modal.Title className="tfbp-modal-title text-uppercase">
          Add Notes For {pannel} {caseProvider?.name}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={sendData}>
        <Modal.Body className="treatment-notes-modal-body">
          <Form.Group controlId="note_description_panel-treatment" className="mb-0">
            <Form.Label className="treatment-notes-field-label">New Note</Form.Label>
            <Form.Control as="textarea" name="description" ref={descriptionRef} rows={3} />
          </Form.Group>
          <NotesModalHistory data={data} module={module} />
        </Modal.Body>
        <Modal.Footer className="treatment-notes-modal-footer">
          <Button
            variant="secondary"
            type="button"
            className="height-25 d-flex align-items-center justify-content-center"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            type="submit"
            className="height-25 d-flex align-items-center justify-content-center"
            disabled={saving}
          >
            {saving ? "Saving..." : "Add Note"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default NoteAddModalTreatment;
